// this file added by Bearer Web Developer
const getToday = ()=>{
    const dateObj = new Date();
    const month   = dateObj.getUTCMonth() + 1; // months from 1-12
    const day     = dateObj.getUTCDate();
    const year    = dateObj.getUTCFullYear();
    const newDate = year + "-" + (month < 10 ? `0${month}` : month) + "-" + (day < 10 ? `0${day}` : day);
    return newDate // Today FORMAT YYYY-MM-DD
}
export default getToday;